let { View } = window.App;

class ScrollTo{
    constructor( el ){
        this.el = el;
        this.$el = $( el );
        this.$target = $( this.el.hash );

        this.$el.on( 'click', $.proxy( this.scrollTo, this ) );
    }

    scrollTo( e ){
        if( !this.$target.length ) return true;
        e.preventDefault();
        let pos = this.$target.offset().top;
        App.$bodyHtml.animate( { scrollTop: pos }, 700 );
    }
}

View.addHook( 'render', v => {
    v.$( '.js-scroll-to' ).each( ( _, el ) => { new ScrollTo( el ) } );
} );



// WEBPACK FOOTER //
// ./resources/js/modules/scroll-to.js